namespace $ {

	export function $shm_projects_task_create_enabled( project_id: string ) {
		return true
	}

	export function $shm_projects_task_import( project_id: string, task: $shm_projects_task_record ) {
		return task
	}
	export function $shm_projects_task_create( project_id: string ) {
		const tasks = [ ... $shm_projects_tasks_list( project_id ) ]
		const number = tasks.reduce( ( maximum, task )=> Math.max( maximum, Number( task.title.match( /^Задача (\d+)$/ )?.[1] || 0 ) ), 0 ) + 1
		const now = Date.now()
		const creator = $shm_projects_goal_api.initiator_provider()
		const task: $shm_projects_task_record = {
			id: `${ now.toString( 36 ) }-${ Math.random().toString( 36 ).slice( 2, 10 ) }`,
			legacy_id: '',
			project_id,
			title: `Задача ${ number }`,
			description: '',
			result: '',
			run_id: '',
			status: 'draft',
			creator_id: creator?.profile_id ?? '',
			creator_name: creator?.profile_name ?? '',
			assignee_id: creator?.profile_id ?? '',
			assignee_name: creator?.profile_name ?? '',
			acceptance_criteria: '',
			priority: 'normal',
			revision: 0,
			planned_revision: 0,
			mode: 'plan',
			pinned: false,
			archived: false,
			created_at: now,
			updated_at: now,
		}
		$mol_state_local.value( `$shm_projects_tasks(${ project_id })`, [ task, ... tasks ] )
		return task
	}
}
